import React, { useState } from "react";
import {
  AppBar, Toolbar, Typography, IconButton, Drawer,
  List, ListItem, ListItemButton, ListItemIcon,
  ListItemText, Divider, Box, Avatar,
  useTheme, useMediaQuery
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import InfoIcon from "@mui/icons-material/Info";
import LogoutIcon from "@mui/icons-material/Logout";

const drawerWidth = 240;
const miniWidth = 65;

export default function Header() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const toggleDrawer = () => setOpen(!open);

  const menuItems = [
    {
      text: "About",
      icon: <InfoIcon />,
      action: () => alert("Room Temperature Online v1.0")
    },
    {
      text: "Logout",
      icon: <LogoutIcon />,
      action: () => {
      const confirmLogout = window.confirm("Are you sure you want to logout?");
        if (confirmLogout) {
          document.cookie = "AccessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.href = window.location.origin;
        }
      }
    }
  ];


  const drawerContent = (
    <Box>
      {/* Drawer Header */}
      <Toolbar sx={{ justifyContent: open ? "flex-start" : "center" }}>
        <Avatar src="/logo.svg" sx={{ width: 35, height: 35, mr: open ? 1 : 0 }} />
        {open && (
          <Typography variant="h6">
            Menu
          </Typography>
        )}
      </Toolbar>
      <Divider />

      {/* Menu List */}
      <List>
        {menuItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              onClick={item.action}
              sx={{ justifyContent: open ? "initial" : "center", px: 2.5 }}>
              <ListItemIcon
                sx={{ justifyContent: "center", minWidth: 0, mr: open ? 2 : 0 }}>
                {item.icon}
              </ListItemIcon>
              {open && (
                <ListItemText primary={item.text} />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );


  return (

    <Box sx={{ display: "flex" }}>
      <AppBar position="fixed" sx={{
          width: isMobile ? "100%" : `calc(100% - ${open ? drawerWidth : miniWidth}px)`,
          ml: isMobile ? 0 : `${open ? drawerWidth : miniWidth}px`
        }}>

        <Toolbar sx={{ position: "relative" }}>
          <IconButton color="inherit" edge="start" onClick={toggleDrawer} sx={{ position: "absolute", left: 16 }}>
            <MenuIcon />
          </IconButton>

          <Box sx={{display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%"}} component="div">
            <Avatar src="/logo.svg" sx={{ width: 35, height: 35, mr: 1 }} />
            <Typography variant="h6">Room Temperature Online</Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {isMobile ? (
        <Drawer open={open} onClose={toggleDrawer}>
          {drawerContent}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          sx={{
            width: open ? drawerWidth : miniWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: open ? drawerWidth : miniWidth,
              overflowX: "hidden",
              transition: "0.3s"
            }
          }} >
          {drawerContent}
        </Drawer>
      )}

      <Toolbar />
    </Box>
  );
}